import Input from "@Components/Input";
import style from "../AddReview.module.scss";
import StarRating from "./StarRating";
import ImagePicker from "./ImagePicker";
import wrapperHOC from "@Utils/wrapperHOC";
import { RATING_CATEGORIES } from "../../constants";
import useTranslationHook from "hooks/useTranslationHook";

const AddReviewForm1 = ({
  review,
  setReview,
  showError = false,
  setShowError,
  isDesktop = false,
  hasExistingReview = false,
}: any) => {
  const { t } = useTranslationHook();
  const updateDetail = (key: string, val: number) => {
    const details = { ...(review.rating_details || {}), [key]: val };
    setReview({ ...review, rating_details: details });
  };
  return (
    <div className={style.reviewForm}>
      <div className={style.fieldSet}>
        <div className={style.fieldLabel}>
          {t("propertypage.reviewssection.addreview.addreviewform.rateexperience")}{" "}
          <span style={{ color: "red" }}>*</span>
        </div>
        <StarRating
          setShowError={setShowError}
          onChange={(val: number) => {
            setReview({ ...review, rating: val });
            if (setShowError) setShowError(false);
          }}
          defaultRating={review?.rating || 0}
          showDisplay={isDesktop}
        />
        {showError && (
          <div style={{ color: "red" }}>
            {t("propertypage.reviewssection.addreview.addreviewform.errorrateexperience")}
          </div>
        )}
      </div>

      {/* Desktop: Show specific categories first, then feedback */}
      {isDesktop && (
        <>
          <div className={style.fieldSet}>
            {RATING_CATEGORIES.map((category) => (
              <div key={category.key} className={style.uspRating}>
                <span className={style.uspTitle}>
                  {category.id}. {category.label.desktop}
                </span>
                <StarRating
                  showDisplay={false}
                  starSize={22}
                  onChange={(val: any) => updateDetail(category.key, val)}
                  defaultRating={review?.rating_details?.[category.key] || 0}
                />
              </div>
            ))}
          </div>
          <div className={style.fieldSet}>
            <div className={style.fieldLabel}>
              Share detailed feedback <span style={{ color: "red" }}>*</span>
            </div>
            <div className={style.fieldSetInner}>
              <Input
                value={review["content"]}
                type="textArea"
                placeholder="Share what you loved and what could have been better"
                label="Share what you loved and what could have been better"
                showPlaceholder
                className={style.reviewInput}
                onChange={(value: any) => {
                  setReview({ ...review, content: value });
                }}
                isTextAreaInput
                maxLength={500}
              />
              <div className={style.maxLimit}>Max 500 characters</div>
            </div>
          </div>
        </>
      )}

      {/* Mobile: Show specific categories after overall rating, then feedback */}
      {!isDesktop && (
        <>
          <div className={style.fieldSet}>
            {RATING_CATEGORIES.map((category) => (
              <div key={category.key} className={style.uspRating}>
                <span className={style.uspTitle}>
                  {category.id}. {category.label.mobile}
                </span>
                <StarRating
                  showDisplay={false}
                  starSize={22}
                  onChange={(val: any) => updateDetail(category.key, val)}
                  defaultRating={review?.rating_details?.[category.key] || 0}
                />
              </div>
            ))}
          </div>
          <div className={style.fieldSet}>
            <div className={style.fieldLabel}>
              Share detailed feedback <span style={{ color: "red" }}>*</span>
            </div>
            <div className={style.fieldSetInner}>
              <Input
                value={review["content"]}
                type="textArea"
                placeholder="Share what you loved and what could have been better"
                label="Share what you loved and what could have been better"
                showPlaceholder
                className={style.reviewInput}
                onChange={(value: any) => {
                  setReview({ ...review, content: value });
                }}
                isTextAreaInput
                maxLength={500}
              />
              <div className={style.maxLimit}>Max 500 characters</div>
            </div>
          </div>
        </>
      )}

      <div className={style.fieldSet}>
        <div className={style.fieldLabel}>
          Upload photos <span style={{ color: "red" }}>*</span>
        </div>
        <div className={style.fieldSetInner}>
          <ImagePicker
            setReview={setReview}
            review={review}
            hasExistingReview={hasExistingReview}
          />
        </div>
      </div>
    </div>
  );
};
export default wrapperHOC(AddReviewForm1, {
  componentName: "AddReviewForm1-ReviewsSection",
  showForChina: true,
});
